import style from './InlineMessage.css';
import { renderIf } from '../../../utils/render.utils';
import ExclamationOutlinedIcon from '../Icons/ExclamationOutlinedIcon';
import Tooltip from '../Tooltip/Tooltip';

export default function InlineMessage({
  className = '',
  textKey,
  textValue,
  hasIcon = false,
  tooltipText = '',
  showTooltip = false,
}) {
  function icon() {
    if (hasIcon)
      return (
        <div className={style.icon}>
          <ExclamationOutlinedIcon />
        </div>
      );
    return '';
  }

  return (
    <div className={`${className} ${style.inline}`}>
      <span className={style.text}>{textKey}</span>
      <span className={style.text}>{textValue}</span>
      {showTooltip ? <Tooltip content={tooltipText}>{icon()}</Tooltip> : icon()}
    </div>
  );
}
